(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-section"] && !Shopify.designMode) return;
  try {
    
     document.addEventListener("DOMContentLoaded", (event) => {
      gsap.fromTo(".nuvoletta", {
        rotation: -10,
      }, {
        rotation: 10,
        duration: 5,
        repeat: -1,
        yoyoEase: "power1.inOut",
      })

       const scrollTriggerConfig = {
    trigger: ".hero-section",
    start: "top top",
    markers: false,
    scrub: 5,
  };

       gsap.to(".nuvoletta", {
         scrollTrigger: scrollTriggerConfig,
         y: 100,
         duration: 2,

       })

             gsap.from(".nuvoletta2",  {
           scrollTrigger: scrollTriggerConfig,
        x: 40,
           duration: 2,
      })

              gsap.to(".nuvoletta3",  {
       scrollTrigger: scrollTriggerConfig,
        y: -30,
           duration: 1,
      })

             gsap.to(".nuvoletta4",  {
        scrollTrigger: scrollTriggerConfig,
        y: -23,
               rotation: 30,
           duration: 1,
      })

       gsap.to(".star1", {
         scrollTrigger: scrollTriggerConfig,
         y: 40,
         rotation: 50,
         duration: Math.floor(Math.random() * 5)
       })

         gsap.to(".star2", {
         scrollTrigger: scrollTriggerConfig,
         y: 20,
         rotation: -50,
         duration: Math.floor(Math.random() * 5)
       })

         gsap.to(".star3", {
         scrollTrigger: scrollTriggerConfig,
         y: 100,
         rotation: -50,
         duration: Math.floor(Math.random() * 5)
       })

          gsap.to(".star4", {
         scrollTrigger: scrollTriggerConfig,
         y: 50,
         rotation: 100,
         duration: Math.floor(Math.random() * 5)
       })


    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section-gsap"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", (event) => {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 992px)", () => {
         gsap.registerPlugin(ScrollTrigger)
  gsap.to(".image-anim", {
    duration: 1,
    y: -75,
    delay: 1,
  });
    })


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
